export default "__VITE_ASSET__Dwd9SL9g__"